var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsubscribeLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161535",
    "data-name": "Group 161535",
    transform: "translate(-376 -676)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140379",
    "data-name": "Rectangle 140379",
    width: 26,
    height: 26,
    transform: "translate(376 676)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle",
    transform: "translate(377.128 678.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M11.478,3.99,1.855,20.058A2.273,2.273,0,0,0,3.8,23.466H23.044a2.273,2.273,0,0,0,1.945-3.412L15.364,3.99a2.273,2.273,0,0,0-3.885,0Z",
    transform: "translate(-1.552 -2.897)",
    fill: "none",
    stroke: "#f09d18",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    y2: 4.544,
    transform: "translate(11.869 6.932)",
    fill: "none",
    stroke: "#f09d18",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 0.012,
    transform: "translate(11.869 16.02)",
    fill: "none",
    stroke: "#f09d18",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribeLargeIcon);
export default __webpack_public_path__ + "static/media/unsubscribe-large-icon.1807fa038b8f066449ba6690d9eee54b.svg";
export { ForwardRef as ReactComponent };